module.exports = __webpack_public_path__ + "img/15.2a932989.png";